import React from 'react';
import { PRODUCT_NAME } from './constants';
export function Footer() {
  return <footer className="py-6 px-4 bg-brand-ink text-center text-white/50 text-xs" data-id="element-74">
      <div className="max-w-3xl mx-auto space-y-3" data-id="element-75">
        <p className="leading-snug max-w-2xl mx-auto font-medium" data-id="element-76">
          © 2026 {PRODUCT_NAME} — All Rights Reserved. The information provided
          on this website is intended for educational purposes only and is
          designed as a professional coaching resource for gymnastics coaches
          and instructors. It is not intended to replace professional coaching
          judgment or the safety standards of your club, federation, or
          governing organization. Always apply your professional expertise and
          prioritize athlete safety during every training session.
        </p>
        <div className="flex justify-center gap-3 font-bold tracking-wide uppercase text-white/60" data-id="element-77">
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-78">
            Terms &amp; Conditions
          </a>
          <span data-id="element-79">·</span>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-80">
            Privacy Policy
          </a>
          <span data-id="element-81">·</span>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-82">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}